class FormationApi {
  async getFormations(accessToken) {
    const urlFormations = `${process.env.REACT_APP_API_URL}/api/formations`;

    const resp = await fetch(urlFormations, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  /**
   * Liste allégée des formations : id, name, format, professions.
   *
   * À utiliser partout où l'on ne fait que peupler un sélecteur ou un filtre.
   * `getFormations` renvoie la fiche complète — 1,6 Mo pour 237 formations,
   * dont 91 % de HTML (resume, goals, programme) inutile dans ce cas.
   */
  async getFormationOptions(accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/options`;

    const resp = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getAllInfosFiltersFormations(accessToken) {
    const urlFormations = `${process.env.REACT_APP_API_URL}/api/getAllInfosFiltersFormations`;

    const resp = await fetch(urlFormations, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  // async getAllFonctionsFormations(accessToken) {
  //   const urlFormations = `${process.env.REACT_APP_API_URL}/api/getAllFonctionsFormations`;

  //   const resp = await fetch(urlFormations, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   });

  //   const json = await resp.json();

  //   return Promise.resolve(json.data);
  // }

  // async getAllFormatFormations(accessToken) {
  //   const urlFormations = `${process.env.REACT_APP_API_URL}/api/getAllFormatFormations`;

  //   const resp = await fetch(urlFormations, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   });

  //   const json = await resp.json();

  //   return Promise.resolve(json.data);
  // }

  // async getAllActionTypesFormations(accessToken) {
  //   const urlFormations = `${process.env.REACT_APP_API_URL}/api/getAllActionTypesFormations`;

  //   const resp = await fetch(urlFormations, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   });

  //   const json = await resp.json();

  //   return Promise.resolve(json.data);
  // }

  async getOrientations(year, accessToken) {
    const urlOrientations = `${process.env.REACT_APP_API_URL}/api/orientations`;
    const resp = await fetch(urlOrientations, {
      method: 'POST',
      body: JSON.stringify(year),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async getFormation(idFormation, accessToken) {
    const urlFormation = `${process.env.REACT_APP_API_URL}/api/formations/${idFormation}`;

    const resp = await fetch(urlFormation, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async updateFormation(FormationId, values, accessToken) {
    const URL_UPDATE = `${process.env.REACT_APP_API_URL}/api/formations/update-formation`;
    values.id = FormationId;
    const resp = await fetch(URL_UPDATE, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async deleteFormation(formationId, accessToken) {
    const URL_UPDATE = `${process.env.REACT_APP_API_URL}/api/formations/delete-formation`;
    const resp = await fetch(URL_UPDATE, {
      method: 'POST',
      body: JSON.stringify(formationId),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async editFormation(field, value, formationId, accessToken) {
    const URL_EDIT = `${process.env.REACT_APP_API_URL}/api/formations/edit_formation`;
    const resp = await fetch(URL_EDIT, {
      method: 'POST',
      body: JSON.stringify({ field, value, formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async getPrices(formationId, accessToken) {
    const URL_EDIT = `${process.env.REACT_APP_API_URL}/api/formations/prices`;
    const resp = await fetch(URL_EDIT, {
      method: 'POST',
      body: JSON.stringify(formationId),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async setPublic(pub, formationId, accessToken) {
    const URL_EDIT = `${process.env.REACT_APP_API_URL}/api/formations/set-public`;
    const resp = await fetch(URL_EDIT, {
      method: 'POST',
      body: JSON.stringify({ pub, formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async createFormation(values, accessToken) {
    const URL_CREATE = `${process.env.REACT_APP_API_URL}/api/formations/create-formation`;
    const resp = await fetch(URL_CREATE, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async deleteSession(id, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/formations/delete-session`;
    const resp = await fetch(URL_DELETE, {
      method: 'POST',
      body: JSON.stringify(id),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  async getUnits(formationId, accessToken) {
    const URL_UNITS = `${process.env.REACT_APP_API_URL}/api/formations/get-units`;
    const resp = await fetch(URL_UNITS, {
      method: 'POST',
      body: JSON.stringify(formationId),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async modifyUnits(modifyUnits, accessToken) {
    const URL_MODIFY_UNITS = `${process.env.REACT_APP_API_URL}/api/formations/modify-units`;
    const resp = await fetch(URL_MODIFY_UNITS, {
      method: 'POST',
      body: JSON.stringify(modifyUnits),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async deleteUnit(unitId, accessToken) {
    const URL_DELETE_UNIT = `${process.env.REACT_APP_API_URL}/api/formations/delete-unit`;
    const resp = await fetch(URL_DELETE_UNIT, {
      method: 'POST',
      body: JSON.stringify(unitId),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async addUnit(unitAdd, formationId, orderUnit, accessToken) {
    const URL_ADD_UNIT = `${process.env.REACT_APP_API_URL}/api/formations/add-unit`;
    const resp = await fetch(URL_ADD_UNIT, {
      method: 'POST',
      body: JSON.stringify({ unitAdd, formationId, orderUnit }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async getCampaignLogs(formationId, sort = null, user, category, type, limit = 25, page = 0, accessToken) {
    const urlLogs = `${process.env.REACT_APP_API_URL}/api/formation/logs`;
    const values = {};
    values.sort = sort;
    values.user = user;
    values.category = category;
    values.type = type;
    values.formationId = formationId;
    values.limit = limit;
    values.page = page;
    const resp = await fetch(urlLogs, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCampaignLogsInfos(formationId, accessToken) {
    const urlCustomer = `${process.env.REACT_APP_API_URL}/api/formation/logs/infos/${formationId}`;

    const resp = await fetch(urlCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getLogs(accessToken, formationId, sort = null, user, category, type, limit = 25, page = 0) {
    const urlLogs = `${process.env.REACT_APP_API_URL}/api/formation/logs/filtered`;
    const values = {};
    values.sort = sort;
    values.user = user;
    values.category = category;
    values.type = type;
    values.formationId = formationId;
    values.limit = limit;
    values.page = page;
    const resp = await fetch(urlLogs, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getFormationPerformance(formationId, accessToken, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlLogs = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/courses_performance/`;
    const values = {};
    values.course_id = formationId;
    values.user_id = userId;
    const resp = await fetch(urlLogs, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async getSessionPerformance(sessionId, accessToken, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlLogs = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/session_performance/`;
    const values = {};
    values.session_id = sessionId;
    values.user_id = userId;
    const resp = await fetch(urlLogs, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }

 async getCoursesSatisfaction(accessToken, formationId, userId) {
  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toLowerCase();
    const urlCourseSatisfactions = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/courses_satisfaction/`;

    const resp = await fetch(urlCourseSatisfactions, {
      method: 'POST',
      body : JSON.stringify({
        user_id : userId,
        course_id : formationId
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
   } });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async getSessionSatisfaction(accessToken, sessionId, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlCourseSatisfactions = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/session_satisfaction/`;

    const resp = await fetch(urlCourseSatisfactions, {
      method: 'POST',
      body : JSON.stringify({
        user_id : userId,
        session_id : sessionId
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
   } });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async getFormationsForSatisfactions(accessToken, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlFormations = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/satisfaction_table/`;

    const resp = await fetch(urlFormations, {
      method: 'POST',
      body : JSON.stringify({
        user_id : userId
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json);
  }
  
  async getFormationsForPerformances(accessToken, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlFormations = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/performance_table/`;

    const resp = await fetch(urlFormations, {
      method: 'POST',
      body : JSON.stringify({
        user_id : userId
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json);
  }

  async getPerformanceFormationGraphsDataBySessions(formationId, accessToken, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlFormations = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/performance_graph/`;

    const resp = await fetch(urlFormations, {
      method: 'POST',
      body : JSON.stringify({
        user_id : userId,
        course_id : formationId,
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json);
  }

  async getSatisfactionFormationGraphsDataBySessions(formationId, accessToken, userId) {
    const { hostname } = window.location;
    const tenant = hostname.split('.')[0].toLowerCase();
    const urlFormations = `${process.env.REACT_APP_API_DJANGO_URL}/${tenant}/api/satisfaction_graph/`;

    const resp = await fetch(urlFormations, {
      method: 'POST',
      body : JSON.stringify({
        user_id : userId,
        course_id : formationId,
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json);
  }

  async saveDocument(formData, accessToken) {
    const urlFormations = `${process.env.REACT_APP_API_URL}/api/formation/save_document`;
    const resp = await fetch(urlFormations, {
      method: 'POST',
      body : formData,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json);
  }

  async loadDocuments(formationId, accessToken) {
    const urlFormations = `${process.env.REACT_APP_API_URL}/api/formation/load_documents`;
    const resp = await fetch(urlFormations, {
      method: 'POST',
      body : JSON.stringify({
        formation_id : formationId,
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json);
  }

  async deleteDocument(documentId, accessToken) {
    const URL_DELETE = `${process.env.REACT_APP_API_URL}/api/formation/delete_document`;
    const resp = await fetch(URL_DELETE, {
      method: 'POST',
      body: JSON.stringify({ documentId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json;
  }

  // Méthodes pour les financeurs
  async getFinanciers(accessToken) {
    const urlFinanciers = `${process.env.REACT_APP_API_URL}/api/formations/financiers`;
    const resp = await fetch(urlFinanciers, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async getFormationFinanciers(formationId, accessToken) {
    const urlFormationFinanciers = `${process.env.REACT_APP_API_URL}/api/formations/financiers/${formationId}`;
    const resp = await fetch(urlFormationFinanciers, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async saveFormationFinanciers(formationId, financeurs, accessToken) {
    const urlSaveFinanciers = `${process.env.REACT_APP_API_URL}/api/formations/financiers/save`;
    const resp = await fetch(urlSaveFinanciers, {
      method: 'POST',
      body: JSON.stringify({ formationId, financeurs }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async deleteFormationFinancier(formationId, financierId, accessToken) {
    const urlDeleteFinancier = `${process.env.REACT_APP_API_URL}/api/formations/financiers/delete`;
    const resp = await fetch(urlDeleteFinancier, {
      method: 'POST',
      body: JSON.stringify({ formationId, financierId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  // Méthodes pour les formateurs / intervenants de la formation
  async getFormationIntervenants(formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/intervenants`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async addFormationIntervenant(formationId, intervenantId, role, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/intervenants/add`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId, intervenantId, role }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async removeFormationIntervenant(linkId, formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/intervenants/remove`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ linkId, formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  // Méthodes pour les prises en charge (dispositif + référence + professions + prix)
  async getFormationPrisesEnCharge(formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/prises-en-charge`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async saveFormationPriseEnCharge(payload, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/prises-en-charge/save`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async removeFormationPriseEnCharge(id, formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/prises-en-charge/remove`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ id, formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  // Indicateurs résultats (calculés depuis le suivi des réponses)
  async getFormationIndicateurs(formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/indicateurs-resultats`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  /** Déroulé pédagogique : liste de modules (onglet « Programme & Objectifs »). */
  async getFormationProgramme(formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/programme`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  /** { available, generaux: [string], operationnels: [{ texte, chapitres: [int] }] } */
  async getFormationObjectifs(formationId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/objectifs`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async updateFormationObjectifs(formationId, objectifs, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/objectifs/update`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId, objectifs }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }

  async updateFormationProgramme(formationId, programme, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/formations/programme/update`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ formationId, programme }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    return json;
  }
}

export const formationApi = new FormationApi();
